import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';

export const ListDividerWithText: React.FC = (props) => {
  return (
    <Flex alignItems="center">
      <Divider borderColor="gray.300" />
      <Box px="4">
        <Text textStyle="detail" color="gray.600">
          {props.children}
        </Text>
      </Box>
      <Divider borderColor="gray.300" />
    </Flex>
  );
};
